import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import RegisterForm from '../../components/RegisterForm';
import FestifyLogo from '../../components/FestifyLogo';
import './styles.css';

function Register() {
  const navigate = useNavigate();
  const [successMsg, setSuccessMsg] = useState('');

  const handleSuccess = () => {
    setSuccessMsg('Cadastro realizado! Redirecionando para login...');
    setTimeout(() => {
      navigate('/login');
    }, 2000);
  };

  return (
    <div className="page-container register-page">
      <div className="card">
        <FestifyLogo subtitle="Crie seu evento e convide com estilo" />
        <h1 className="card-title">Cadastrar</h1>
        {successMsg && <p className="success-banner">{successMsg}</p>}
        <RegisterForm onSuccess={handleSuccess} />
        <p className="toggle-text">
          Já tem conta? <Link to="/login" className="toggle-btn">Faça login</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
